module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/tile_winterparties-d2b16a3c7a8d1dea1f1aa2bbb985ea0b.jpg";